import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  CATEGORIES: "api/CRM/Categories",
  ADD_CATEGORY: "api/CRM/AddCategory",
  UPDATE_CATEGORY: "api/CRM/UpdateCategory",
  CHILD_CATEGORIES: "api/CRM/ChildCategories",
  DELETE_CATEGORY: "api/CRM/Category",
  DOWNLOAD_ALL_CATEGORIES: "api/CRM/Category/Export",
  CATEGORY_BULK_UPLOAD: "api/CRM/CategorysBulkUpload",
  CATEGORIES_REPORT:
    "api/CRM/Categories/BulkUpload/FileName?loadtype=Categorys",
  EXPORT_BULK_UPLOAD_REPORT: "api/CRM/Category/BulkUpload/ExportReport",
  EXPORT_BULK_UPLOAD_FILE: "api/CRM/Category/BulkUpload/ExportFile",
  VIEW_BULK_UPLOAD_REPORT: "api/CRM/Category/BulkUpload/ViewReport",
};

export const formatDateTime = (isoString: string): string => {
  if (!isoString) return "-";

  const date = new Date(isoString);

  return date
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(",", "");
};

const fetchBulkUploadViewReports = async (payload: any) => {
  const response = await privateRequest.get(ENDPOINTS.VIEW_BULK_UPLOAD_REPORT, {
    params: payload,
  });
  return response.data;
};

const exportBulkUploadReport = async (fileId: string) => {
  const response = await privateRequest.post(
    `${ENDPOINTS.EXPORT_BULK_UPLOAD_REPORT}/${fileId}`,
    {},
    { responseType: "arraybuffer" }
  );
  return response;
};

const exportBulkUploadFile = async (fileId: string) => {
  const response = await privateRequest.post(
    `${ENDPOINTS.EXPORT_BULK_UPLOAD_FILE}/${fileId}`,
    {},
    { responseType: "arraybuffer" }
  );
  return response;
};

const fetchCategoriesReport = async (payload: any) => {
  const response = await privateRequest.get(ENDPOINTS.CATEGORIES_REPORT, {
    params: payload,
  });
  return response.data;
};

const fetchCategories = async (payload: any): Promise<ApiResponse<any[]>> => {
  const response = await privateRequest.get(ENDPOINTS.CATEGORIES, {
    params: payload,
  });
  return response.data;
};

const fetchChildCategories = async (): Promise<ApiResponse<any[]>> => {
  const response = await privateRequest.get(ENDPOINTS.CHILD_CATEGORIES);
  return response.data;
};

const addNewCategory = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.ADD_CATEGORY, payload);
  return response.data;
};

const updateCategory = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(
    ENDPOINTS.UPDATE_CATEGORY,
    payload,
  );
  return response.data;
};

const deleteCategory = async (id: number) => {
  const res = await privateRequest.delete(`${ENDPOINTS.DELETE_CATEGORY}/${id}`);
  return res.data;
};

const downloadAllCategories = async () => {
  const response = await privateRequest.get(ENDPOINTS.DOWNLOAD_ALL_CATEGORIES, { responseType: "arraybuffer" });
  return response;
};

const categoryBulkUpload = async (payload: any): Promise<any> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.CATEGORY_BULK_UPLOAD}`,
    payload,
  );
  return res.data;
};

const CategoryMasterService = {
  fetchCategories,
  fetchChildCategories,
  addNewCategory,
  updateCategory,
  deleteCategory,
  downloadAllCategories,
  categoryBulkUpload,
  fetchCategoriesReport,
  exportBulkUploadReport,
  exportBulkUploadFile,
  fetchBulkUploadViewReports
};

export default CategoryMasterService;
